import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex flex-wrap px-2 py-1" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "flex items-start pt-2.5 mr-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_accordion_open_icon = _resolveComponent("base-accordion-open-icon")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "tagRef",
    class: "bg-white flex justify-between overflow-hidden duration-500 transition-all px-2",
    style: _normalizeStyle(_ctx.heightStyle)
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.getters['tag/filterdTagList'](_ctx.hiddenTagIds), (item) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item.id,
            class: "p-1"
          }, [
            _createElementVNode("div", {
              onClick: ($event: any) => (_ctx.clickTag(item.id)),
              class: _normalizeClass([_ctx.classSelected(item.id), "cursor-pointer border rounded-full text-sm font-medium py-1 px-3 whitespace-nowrap select-none"])
            }, _toDisplayString(item.name), 11, _hoisted_2)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_base_accordion_open_icon, {
        onClick: _ctx.clickOpen,
        isOpen: _ctx.isOpen
      }, null, 8, ["onClick", "isOpen"])
    ])
  ], 4))
}